import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import AiPanel from './AiPanel';
import { useUIStore } from '../store';

export default function Layout() {
  const { sidebarOpen, aiPanelOpen } = useUIStore();

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <div className={`${sidebarOpen ? 'w-64' : 'w-0'} transition-all duration-300 ease-in-out overflow-hidden flex-shrink-0`}>
        <Sidebar />
      </div>
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-auto p-4">
          <Outlet />
        </main>
      </div>
      {aiPanelOpen && <div className="w-96 flex-shrink-0"><AiPanel /></div>}
    </div>
  );
}
